import { Injectable } from '@angular/core';
import { SftpInfo } from '@core/services/sftp/sftp-info.model';
import { SftpInfoService } from '@core/services/sftp/sftp-info.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as sftpsActions from './sftp-info.actions';

@Injectable()
export class SftpInfoEffect {
  constructor(private actions$: Actions, private sftpService: SftpInfoService) {}

  /*****Load ALL SftpInfos*****/

  loadSftpInfos$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<sftpsActions.LOADSFTPINFOS>(sftpsActions.SftpInfoActionTypes.LOAD_SFTPINFOS),
      mergeMap((actions: sftpsActions.LOADSFTPINFOS) =>
        this.sftpService.AllSftpInfo().pipe(
          map((sftpinfos: SftpInfo[]) => new sftpsActions.LOADSFTPINFOSSUCCESS(sftpinfos)),
          catchError(err => of(new sftpsActions.LOADSFTPINFOSFAIL(err)))
        )
      )
    )
  );

  /*****Create SFTP*****/

  createSftp$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<sftpsActions.CREATESFTP>(sftpsActions.SftpInfoActionTypes.CREATE_SFTPINFO),
      map((action: sftpsActions.CREATESFTP) => action.payload),
      mergeMap((sftp: SftpInfo) =>
        this.sftpService.createSftp(sftp).pipe(
          map((newSftp: SftpInfo) => new sftpsActions.CREATESFTPSUCCESS(newSftp)),
          catchError(err => of(new sftpsActions.CREATESFTPFAIL(err)))
        )
      )
    )
  );

  /*****Update SFTP*****/

  updateSftp$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<sftpsActions.UPDATESFTP>(sftpsActions.SftpInfoActionTypes.UPDATE_SFTPINFO),
      map((action: sftpsActions.UPDATESFTP) => action.payload),
      mergeMap((sftp: SftpInfo) =>
        this.sftpService.updateSftp(sftp).pipe(
          map(
            (updateSftp: number) =>
              new sftpsActions.UPDATESFTPSUCCESS({
                id: sftp.id,
                changes: sftp,
              })
          ),
          catchError(err => of(new sftpsActions.UPDATESFTPFAIL(err)))
        )
      )
    )
  );
}
